import { Menu, MenuItem, SubMenu } from "@szhsin/react-menu"
import PropTypes from "prop-types"
import React from "react"

import { withTranslation } from "../../i18n/translate"
import "./context-menu.sass"
import "./menu.scss"

class ContextMenu extends React.Component {
  constructor(props) {
    super(props)

    this.state = { s: false, options: props.options || [] }
  }

  componentDidUpdate() {
    if (this.state.options !== this.props.options) {
      this.setState({
        options: this.props.options,
      })
    }
  }

  onBlur() {
    this.blurTimer = setTimeout(() => {
      this.close()
    }, 0)
  }

  onFocus() {
    clearTimeout(this.blurTimer)
  }

  onKeyPress(ev) {
    if (ev.defaultPrevented) return
    if (ev.key === "Enter") {
      if (this.state.s) {
        this.close()
      } else {
        this.open()
      }
    }
  }

  onItemKeyPress(ev, item) {
    if (ev.key === "Enter") {
      ev.preventDefault()
      this.execCallback(item)
    }
  }

  open() {
    this.setState({ s: true })
  }

  close() {
    this.setState({ s: false })
  }

  execCallback(item) {
    this.close()
    item.callback && item.callback()
  }

  render() {
    const { t, children } = this.props
    const { options } = this.state

    return (
      <Menu menuButton={children}>
        {options.map((option, index) => {
          if (option.children) {
            return (
              <SubMenu key={"menuitem_" + index} label={t(option.label)}>
                {option.children.map((option, index) => (
                  <MenuItem
                    key={"submenuitem_" + index}
                    onClick={() => this.execCallback(option)}
                  >
                    {t(option.label)}
                  </MenuItem>
                ))}
              </SubMenu>
            )
          }
          return (
            <MenuItem
              key={"menuitem_" + index}
              onClick={() => this.execCallback(option)}
            >
              {t(option.label)}
            </MenuItem>
          )
        })}
      </Menu>
    )
  }
}

ContextMenu.propTypes = {
  options: PropTypes.array.isRequired,
}

export default withTranslation()(ContextMenu)
